import { render, staticRenderFns } from "./menucolonneverte_parametres_header.vue?vue&type=template&id=6bec3a6f"
import script from "./menucolonneverte_parametres_header.js?vue&type=script&lang=js&external"
export * from "./menucolonneverte_parametres_header.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports